import { getDiagnosisNamesAPI, getDoctorNotesOptionsAPI, getNotesAPI, postNotesAPI, updateNoteAPI } from "../adapter/cms-adapter";
import { checkIfBedIdContainsSession } from "../common/utils/CommonUtils";

export const getNotes = (data) => {

    let reqData = {
        bedId: checkIfBedIdContainsSession(data.bedId),
        patientSessionId: data.patientSessionId,
        type: data.type
    }

    let promise = new Promise((resolve, reject) => {

        getNotesAPI(reqData).then((res) => {
            if (res && res.data && res.data.data) {
                resolve(res.data.data);
            } else {
                reject("Notes error");
            }
        }).catch((err) => {
            reject("Notes error");
        })
    });

    return promise;
}

export const postNotes = (data) => {
    let reqData = data;
    reqData.bedId = checkIfBedIdContainsSession(data.bedId);

    let promise = new Promise((resolve, reject) => {

        postNotesAPI(reqData).then((res) => {
            if (res && res.data && res.data.data) {
                resolve(res.data.data);
            } else {
                reject("Notes error");
            }
        }).catch((err) => {
            reject("Notes error");
        })
    });

    return promise;
}

export const updateNote = (data) => {
    let promise = new Promise((resolve, reject) => {

        updateNoteAPI(data).then((res) => {
            if (res && res.data && res.data.data) {
                resolve(res.data.data);
            } else {
                reject("Notes error");
            }
        }).catch((err) => {
            reject("Notes error");
        })
    });

    return promise;
}
export const getDoctorNotesOptions = (data) => {

    let url = `http://ec2-13-234-112-231.ap-south-1.compute.amazonaws.com:8080/csnoserv/api/search/search?term=${data.name}&state=active&semantictag=${data.semanticTag}&acceptability=preferred&returnlimit=50&refsetid=null&parentid=null&excludeparentconcept=false`
    let promise = new Promise((resolve, reject) => {
        getDoctorNotesOptionsAPI(url).then((res) => {
            if (res) resolve(res);
            else reject("err in fetching options")
        }).catch((err) => {
            reject("err in fetching options", err);
        })
    })
    return promise;

}